import {btn, Component, cookies, Notifier, router, tbar} from "@intermesh/goui";
import {t} from "./util/Translate.js";
import {registrationForm} from "./components/RegistrationForm.js";
import {HttpVerb, ServerApi} from "./util/ServerApi.js";
import {CurrentSection} from "./services/CurrentSection.js";
import {CurrentParticipant} from "./services/CurrentParticipant.js";
import {ifwLog} from "./util/IfwLog.js";

export class ConfirmRegistration extends Component {
	constructor() {
		super("section");
		this.itemId = "confirm-registration";
		this.id = "confirm-registration";
		this.cls = "card";

		const cp = CurrentParticipant.get();
		if(cp.id) {
			router.goto("profile"); // A logged in user should never register again.
		}

		const p = registrationForm({readOnly: true});

		p.form.on("submit", async () => {
			p.form.findChild("remindMe")!.disabled = false;
			let cp = CurrentParticipant.get();
			delete cp.user!.passwordRepeat;

			let route = "elearning/frontend/participants", method = "POST" as HttpVerb;
			if(CurrentParticipant.isInvited()) {
				route += "?invitationToken="+encodeURIComponent(sessionStorage.getItem("invitationToken")!);
			}
			ServerApi.call(route, cp, method).then((result) => {
				if (!result.success) {
					Notifier.warning(t(result.message) || t("Unknown error"), 5000);
					if(!CurrentParticipant.isInvited()) {
						return;
					}
					// #976, There's probably merely something wrong with the invitation. The participant has been made.
					// Continue the authentication, but without the invitation
					sessionStorage.removeItem("invitationToken");
				}
				ServerApi.call("auth", {username: cp.user!.username, password: cp.user!.password}, "POST")
					.then(async (a) => {
						const portalConfig = JSON.parse(localStorage.getItem("portalConfig")!);

						if (portalConfig.mayUseEva) {
							let evaId = sessionStorage.getItem("evaId");

							if (evaId) {
								ServerApi.call('eva/evauser/' + result.data.userId, {}, "GET")
									.then(async (evaUserResult) => {
										ifwLog("Eva", "EvaUser already exists. " + evaUserResult);
									})
									.catch((e) => {
										ServerApi.call('eva/create', {
											userId: result.data.userId,
											evaId: evaId
										}, 'POST')
									});
							}
						}

						cookies.set("accessToken", a.data.accessToken, 0, "/");
						// Force a reload of the current participant data through access and / or invitation tokens.
						sessionStorage.removeItem(CurrentParticipant.storageItem);
						await CurrentParticipant.readIf();
						if (CurrentParticipant.isInvited()) {
							await CurrentParticipant.goToInvitedCourse();
							return;
						} else {
							if (portalConfig.sectionId) {
								const lang = CurrentSection.findLanguage(); // Cheating a bit!
								if (!lang.showInfoPage) {
									router.goto("profile");
								} else {
									router.goto("sectioninfo");
								}
							} else {
								router.goto("profile");
							}
						}
						router.goto("profile");
					});
			}).catch((reason) => {
				Notifier.error(reason);

				router.goto("");
			});
		});

		p.load().then(() => {
			this.items.add(p);
			p.ageCheck();

			this.items.add(tbar({cls: "ifw-bbar"},
				btn({text: t("Back"), route: "register"}),
				"->",
				btn({
					type: "submit", text: t("Continue"), handler: () => {
						p.form.submit();
					}
				})
			));
		});
	}
}
